import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRole } from "@/contexts/RoleContext";
import { useAuth } from "@/contexts/AuthContext";
import { getV2NavForRole } from "@/v2/lib/v2Roles";

/**
 * Bottom nav mobile pour tous les rôles V2 (notamment prestataire qui n'a pas
 * de sidebar). 5 items max — on tronque pour les rôles très garnis.
 */
export function V2MobileNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { role } = useRole();
  const { signOut } = useAuth();

  const navAll = getV2NavForRole(role);
  const nav = navAll.slice(0, 4);

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-surface border-t border-border flex">
      {nav.map((item) => {
        const Icon = item.icon;
        const isActive =
          location.pathname === item.to ||
          location.pathname.startsWith(item.to + "/");
        return (
          <button
            key={item.to}
            type="button"
            onClick={() => navigate(item.to)}
            className={cn(
              "flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium cursor-pointer",
              isActive ? "text-accent" : "text-text-muted",
            )}
          >
            <Icon size={20} />
            <span>{t(item.shortKey ?? item.labelKey)}</span>
          </button>
        );
      })}
      <button
        type="button"
        onClick={async () => {
          await signOut();
          navigate("/login");
        }}
        className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium text-text-muted cursor-pointer"
      >
        <LogOut size={20} />
        <span>{t("v2.nav.short.logout")}</span>
      </button>
    </nav>
  );
}
